import game817 from "./817.png";
import game819 from "./819.png";
import game816 from "./816.png";
import game818 from "./818.png";
import game815 from "./815.png";
import game813 from "./813.png";
import game811 from "./811.png";
import game806 from "./806.png";
import game784 from "./784.png";
import game814 from "./814.png";
import game812 from "./812.png";
import game810 from "./810.png";
import game809 from "./809.png";
import game807 from "./807.png";
import game805 from "./805.png";
import game804 from "./804.png";
import game802 from "./802.png";
import game798 from "./798.png";
import game801 from "./801.png";
import game800 from "./800.png";
import game779 from "./779.png";
import game796 from "./796.png";
import game794 from "./794.png";
import game793 from "./793.png";
import game792 from "./792.png";
import game788 from "./788.png";
import game775 from "./775.png";
import game771 from "./771.png";
import game767 from "./767.png";
import game763 from "./763.png";
import game759 from "./759.png";
import game755 from "./755.png";
import game751 from "./751.png";
import game747 from "./747.png";
import game704 from "./704.png";
import game692 from "./692.png";
import game727 from "./727.png";

export default [
  { type: "betsoft", img: game817, id: 817, name: "Back to Venus!" },
  { type: "betsoft", img: game819, id: 819, name: "Monster Pop" },
  { type: "betsoft", img: game816, id: 816, name: "Spring Tails" },
  { type: "betsoft", img: game818, id: 818, name: "Total Overdrive" },
  { type: "betsoft", img: game815, id: 815, name: "Super Sweets" },
  { type: "betsoft", img: game813, id: 813, name: "Take The Bank" },
  { type: "betsoft", img: game811, id: 811, name: "Gemmed" },
  { type: "betsoft", img: game806, id: 806, name: "BAMBOO RUSH" },
  { type: "betsoft", img: game784, id: 784, name: "SugarPop 2: Double Dipped" },
  { type: "betsoft", img: game814, id: 814, name: "Dragon & Phoenix" },
  { type: "betsoft", img: game812, id: 812, name: "Caishen’s Arrival " },
  { type: "betsoft", img: game810, id: 810, name: "Wolf Moon Rising" },
  { type: "betsoft", img: game809, id: 809, name: "Gold Canyon" },
  { type: "betsoft", img: game807, id: 807, name: "Spinfinity Man" },
  { type: "betsoft", img: game805, id: 805, name: "Viking Voyage" },
  { type: "betsoft", img: game804, id: 804, name: "Fruitbat Crazy" },
  { type: "betsoft", img: game802, id: 802, name: "Carnaval Forever" },
  { type: "betsoft", img: game798, id: 798, name: "Faerie Spells" },
  { type: "betsoft", img: game801, id: 801, name: "Yak, Yeti and Roll" },
  { type: "betsoft", img: game800, id: 800, name: "ChilliPop" },
  // { type: "betsoft", img: game779, id: 779, name: "MAX QUEST: WRATH OF RA" },
  { type: "betsoft", img: game796, id: 796, name: "Dragon Kings" },
  { type: "betsoft", img: game794, id: 794, name: "The Golden Owl of Athena" },
  { type: "betsoft", img: game793, id: 793, name: "Ogre Empire" },
  { type: "betsoft", img: game792, id: 792, name: "Reels of Wealth" },
  { type: "betsoft", img: game788, id: 788, name: "Tiger's Claw" },
  { type: "betsoft", img: game775, id: 775, name: "Legend of the Nile" },
  { type: "betsoft", img: game771, id: 771, name: "Stampede" },
  { type: "betsoft", img: game767, id: 767, name: "Jumbo Joker" },
  { type: "betsoft", img: game763, id: 763, name: "Blood Eternal" },
  { type: "betsoft", img: game759, id: 759, name: "Giovanni's Gems" },
  { type: "betsoft", img: game755, id: 755, name: "Fire & Steel" },
  { type: "betsoft", img: game751, id: 751, name: "Magic Shoppe" },
  { type: "betsoft", img: game747, id: 747, name: "The Angler" },
  { type: "betsoft", img: game704, id: 704, name: "The SlotFather Part II" },
  { type: "betsoft", img: game692, id: 692, name: "Fa-Fa Twins" },
  { type: "betsoft", img: game727, id: 727, name: "Kawaii Kitty" },
];



// WEBPACK FOOTER //
// ./js/sport-betting/components/games/slots/betsoft/assets/index.js